import Pagination from 'react-bootstrap/Pagination';
import React, { useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Button from 'react-bootstrap/esm/Button';
import Form from 'react-bootstrap/Form';

type PaginationProps = {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    id?: string;
    itemsPerPage?: number;
    onItemsPerPageChange?: (itemsPerPage: number) => void;
};

// Shows a limited number of page links around the current page, with ellipsis if needed

const getPageNumbers = ( page: number, totalPages: number, siblingCount = 3) => {
     if (totalPages <= 1) return [1];

     const pageCountBeforeCurrent = page > 3 ? siblingCount : page - 1;
     const pageCountAfterCurrent = page < totalPages - 2 ? siblingCount : totalPages - page;

     let start = page - Math.max(0, pageCountBeforeCurrent);
     let end = page + Math.min(totalPages, pageCountAfterCurrent);
     // displaying fewer pages is permitted if we are near the start or end, so adjust the other side accordingly
     // never display more then siblingCount pages on either side, even if we are near the start or end
     //if (end - page < siblingCount) {
     //    start = Math.max(1, end - siblingCount * 2);
     //}
     //if (page - start < siblingCount) {
     //    end = Math.min(totalPages, start + siblingCount * 2);
     //}
     const result = Array.from({ length: end - start + 1 }, (_, i) => start + i);

     return result;


};


const PaginationGroup: React.FC<PaginationProps> = ({ 
    page, 
    totalPages, 
    onPageChange, 
    id, 
    itemsPerPage = 5, 
    onItemsPerPageChange 
}) => {
    const pageNumbers = getPageNumbers(page, totalPages, 3);
    const [inputValue, setInputValue] = useState("");

    const handleItemsPerPageChange = (e: any) => {
        const newItemsPerPage = parseInt(e.target.value, 10);
        if (onItemsPerPageChange) {
            onItemsPerPageChange(newItemsPerPage);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value.replace(/[^0-9]/g, "");
        setInputValue(val);
    };

    const handleGo = () => {
        let num = parseInt(inputValue, 10);
        if (isNaN(num) || num < 1) num = 1;
        if (num > totalPages) num = totalPages;
        if (num !== page) onPageChange(num);
        setInputValue("");
    };

    const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleGo();
        }
    };

    return (
        <Container className="pagination-layout">
            <Row className="justify-content-center align-items-center">
                {totalPages > 1 &&
                <>
                    <Col md={4} className="d-flex justify-content-center align-items-center my-2">
                        <Pagination id={id ? `${id}-pagination` : undefined} style={{marginBottom:'0'}}>
                            <Pagination.First 
                                disabled={page === 1}
                                onClick={() => onPageChange(1)}
                            />
                            <Pagination.Prev 
                                onClick={() => onPageChange(page - 1)} 
                                disabled={page === 1} 
                            />
                            {pageNumbers[0] > 1 && (
                                <Pagination.Ellipsis />
                            )}
                            {pageNumbers.map((p) => (
                                <Pagination.Item 
                                    key={p}
                                    onClick={() => onPageChange(p)}
                                    active={p === page}
                                    disabled={page === p}
                                >
                                    {p}
                                </Pagination.Item>
                            ))}
                            {pageNumbers[pageNumbers.length - 1] < totalPages && (
                                <Pagination.Ellipsis />
                            )}
                            <Pagination.Next 
                                onClick={() => onPageChange(page + 1)} 
                                disabled={page === totalPages} 
                            />
                            <Pagination.Last 
                                onClick={() => onPageChange(totalPages)} 
                                disabled={page === totalPages} 
                            />
                        </Pagination>
                    </Col>
                        <Col className="d-flex justify-content-center justify-content-md-end my-2">
                        <input
                            id="pageSelect"
                            type="text"
                            className="border rounded text-center"
                            value={inputValue}
                            onChange={handleInputChange}
                            onKeyDown={handleInputKeyDown}
                            placeholder="Page"
                            aria-label="Page number input"
                            style={{width:'5em'}}
                        />
                        <Button
                            className="text-light"
                            type="button"
                            onClick={handleGo}
                            disabled={!inputValue || isNaN(Number(inputValue))}
                            style={{
                                marginInline: '5px'
                            }}
                        >
                            Go
                        </Button>
                        
                    </Col>
                </>
                }
                
                
                {onItemsPerPageChange && (
                    <Col  className=" d-flex justify-content-center justify-content-md-end align-items-center">
                            <label id={id ? `${id}-items-per-page-lbl` : "items-per-page"} htmlFor={id ? `${id}-items-per-page` : "items-per-page"} style={{marginRight: '10px'}} className="opacity-75 text-end">
                                Items per page
                            </label> 
                            
                             <Form.Select
                                id={id ? `${id}-items-per-page` : "items-per-page"}
                                className=""
                                value={itemsPerPage}
                                onChange={(e) => handleItemsPerPageChange(e)}
                                style={{width:'5em'}}
                                aria-labelledby={id ? `${id}-items-per-page` : "items-per-page"}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={100}>100</option>
                            </Form.Select>
                     
                    </Col>
                )}
            </Row>
            
                        
                    
        </Container>
    );
};

export default PaginationGroup;